<template>
  <div>
    <b-tabs content-class="mt-1" class="mt-2" v-model="tabIndex" lazy>
      <b-tab title="Основная информация" :title-link-class="linkClass(0)">
        <EventEdit :id="id" v-model="editItem"/>
      </b-tab>
      <b-tab title="Результаты" :title-link-class="linkClass(1)">
        <ResultTeam :sport-kind-id="editItem.sportKindId"
                    :fed-id="editItem.federationId"
                    :ekp-data-id="editItem.id"/>
      </b-tab>
    </b-tabs>

    <b-modal id="modal-load" centered title="Загрузка данных" v-model="modalLoadOpened"
             hide-header-close no-close-on-backdrop no-close-on-esc hide-footer>
      <p class="text-center">
        <b-spinner></b-spinner>
      </p>
    </b-modal>
  </div>
</template>

<script>
import EventEdit from "@/components/editEventForm/EventEdit.vue"
import ResultTeam from "@/components/resultTeam/ResultTeam.vue"

export default {
  components: {ResultTeam, EventEdit},
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      tabIndex: 0,
      modalLoadOpened: false,
      editItem: {}
    }
  },
  methods: {
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-primary']
      }
    },
  }
}
</script>

<style scoped>

</style>
